import { Constants, IPaymentDataModel } from '@co-assist/library';

export class PaymentData implements IPaymentDataModel {
    paymentMethod: Constants.Payment.PaymentMethod;
    data: any;

    /** TODO: intégrer les modeles creditCard et sepa */
    constructor(object?: any) {
        if (object && object.data && object.paymentMethod === Constants.Payment.PaymentMethod.SEPA) {
            this.paymentMethod = Constants.Payment.PaymentMethod.SEPA;
            this.data = object.data;
        } else if (object && object.data && object.paymentMethod === Constants.Payment.PaymentMethod.CARD) {
            this.paymentMethod = Constants.Payment.PaymentMethod.CARD;
            this.data = object.data;
        } else {
            this.paymentMethod = Constants.Payment.PaymentMethod.NONE;
            this.data = null;
        }
    }

    getType(): string {
        return this.paymentMethod;
    }

    validatePaymentData(): boolean {
        if (this.paymentMethod === 'CREDIT_CARD' &&
            this.data && this.data.number &&
            this.data.holderName &&
            this.data.cvc &&
            this.data.expiryMonth &&
            this.data.expiryYear) {
            return true;
        } else if (this.paymentMethod === 'SEPA_DIRECT' &&
            this.data &&
            this.data.iban &&
            this.data.firstName &&
            this.data.lastName &&
            this.data.mandateAddress &&
            this.data.gender &&
            this.data.mandateAddress.countryCode) {
            return true;
        } else {
            return false;
        }
    }
}

